// TODO: Post-MVP - Implement FeedLoader wrapper interface for advanced infinite scroll features
// Currently using manual "Load More" button (checkLastPage: false)
// Future: Add auto-scroll loading via FeedLoader interface with PathFn, onLoad, onAppend callbacks
// See: ts/grid/grid/grid.ts:426 for current usage
// import {FeedLoader, FeedLoaderOptions} from "@/common/InfiniteScroll/Interfaces/InfiniteScroll";
import InfiniteScroll from "infinite-scroll";

export function createFeedLoader(container: string, opts: InfiniteScroll.Options): InfiniteScroll {
    return new InfiniteScroll(container, opts);
}
